import { useLayoutEffect, useMemo, useState } from 'react';
import type { RefObject } from 'react';

type UnderlineSize = { width: number; left: number };

const calculateSizes = (elements: Array<RefObject<HTMLElement>>) => {
    const root = elements[0]?.current?.parentElement;
    if (!root) return elements.map(() => ({ width: 0, left: 0 }));
    const rootBounds = root.getBoundingClientRect();

    return elements.map(({ current }) => {
        if (!current) return { width: 0, left: 0 };
        const bounds = current.getBoundingClientRect();
        const left = bounds.left - rootBounds.left + root.scrollLeft;

        return {
            width: bounds.width,
            left,
        };
    });
};

export const useUnderlineSlider = (refs: Array<RefObject<HTMLElement>>, activeIdx: number) => {
    const [sizes, setSizes] = useState<UnderlineSize[]>([]);
    const styles = useMemo(() => {
        const size = sizes[activeIdx] || { width: 0, left: 0 };

        return {
            width: size.width,
            transform: `translate3d(${size.left}px, 0px, 0px)`,
        };
    }, [sizes, activeIdx]);
    const changeSizes = () => {
        setSizes(calculateSizes(refs));
    };

    useLayoutEffect(() => {
        changeSizes();
    }, [activeIdx]);

    useLayoutEffect(() => {
        window.addEventListener('scroll', changeSizes);

        return () => window.removeEventListener('scroll', changeSizes);
    }, []);

    return { styles, changeSizes };
};
